import React from "react";
import { Table, Button } from "semantic-ui-react";
import _ from "lodash";
import { connect } from "react-redux";
// import ResultHeader from "./ResultHeader";
import "../../assets/styles/sub-table.css";
// import { getMenuItem } from "../common/PageHelper";
import PiplRecord from "./PiplRecord";
import SimpleAccordionContent from "../common/SimpleAccordionContent";

class PiplReport extends React.Component {
  constructor(props) {
    super(props);
    this.loadData(props);
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
  }

  componentWillReceiveProps(nextProps) {
    this.loadData(nextProps);
  }

  loadData = (props) => {
    const reps = [];
    if (
      props.reportData !== undefined &&
      props.reportData !== null &&
      props.reportData !== ""
    ) {
      const root = Object.keys(props.reportData)[0];
      const persons = _.get(
        props.reportData,
        `${root}.people[0].person`
      );

      if(persons && persons.length > 0) {
        const availableSources = _.get(props.reportData, `${root}.people[0].available_sources[0]._`);
        _.forEach(persons, (person, perindex) => {
            const name = _.get(person, "names[0].name[0].display[0]._", "");
              const res = [];
              res.push(
                <Table.Row key={`social_Row_${perindex}`}>
                  <Table.Cell>
                    <div id="report">
                      <PiplRecord
                        key={`social_Table_${perindex}`}
                        node={person}
                        reportRoot = {root}
                        index={perindex}
                        availableSources={availableSources}
                        {...props}
                      />
                    </div>
                  </Table.Cell>
                </Table.Row>
              );
            reps.push(
          <SimpleAccordionContent custClass={"margin-top-botton-5"}
            {...this.props}
            name={name}
            rows={res}
            key={`social_acc_${perindex}`}
            accId={`social_acc_${perindex}`}
          />
        );
        });
    } else {
      // const resultName = _.get(
      //   props.reportData,
      //   `${root}.result_name[0]`
      // );
      reps.push(
        <Table.Row key={`no_recs_row`}>
          {/* <Table.Cell colSpan={100}>No report found for <span className="red-text"><b>{resultName}</b></span></Table.Cell> */}
          <Table.Cell colSpan={100}>No records found</Table.Cell>
        </Table.Row>
      );
    }
      this.state = {
        reps,
      };
    }
  };

  render() {
    return (<Table stackable>
              <Table.Body>
                <Table.Row>
                  <Table.Cell>
                    <div className={`no-print`}>
                      <Button
                        className={"margin-left-10"}
                        onClick={() => this.props.printContent("report", `Report`)}
                      >
                        Print
                      </Button>{" "}
                    </div>
                  </Table.Cell>
                </Table.Row>
                {this.state.reps}
              </Table.Body>
            </Table>);
  }
}

function mapStateToProps(state) {
  return { userAccount: state.userAccount };
}

export default connect(mapStateToProps, null)(PiplReport);



// WEBPACK FOOTER //
// ./src/components/reports/PiplReport.js